// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE (Supabase migration V2 - PREVIEW ONLY)
// version  : 1.2
// updated  : 2026-06-20
// protected: NO
// changelog: v1.2 (P0) - hapus helper archivePdf() (arsip manual). PDF kini auto-arsip
//            best-effort di backend saat finalisasi & saat PDF di-generate.
// =============================================================================
// Konstanta lokasi/region untuk UI V2 (region tetap ditegakkan backend/RLS).
import { toast } from "sonner";
// Sumber TUNGGAL region-aware (lihat scope.js). Re-export agar import lama tetap jalan.
import {
  GUDANG_BY_REGION, STORE_BY_REGION, WAREHOUSES, STORES,
  allowedRegions, allowedWarehouses, allowedStores, allowedLocations,
  userRegion, isGlobalScope,
} from "@/v2/components/scope";

export {
  GUDANG_BY_REGION, STORE_BY_REGION, WAREHOUSES, STORES,
  allowedRegions, allowedWarehouses, allowedStores, allowedLocations,
  userRegion, isGlobalScope,
};
export const isOwner = (r) => r === "OWNER";

// lokasi default berdasarkan region user
export const defaultGudang = (region) => GUDANG_BY_REGION[region] || "GUDANG_SBY";
export const defaultStore = (region) => STORE_BY_REGION[region] || "STORE_AREMA";

export const rupiah = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");

// ringkas hasil per-item dari endpoint mutasi (success/failed)
export const resultToast = (toast, res, okWord = "diproses") => {
  const ok = res.received ?? res.ok_count ?? (res.result && res.result.ok_count) ?? 0;
  const fail = res.failed_count ?? (res.result && res.result.failed_count) ?? 0;
  if (fail === 0) toast.success(`${ok} item ${okWord}`);
  else toast.warning(`${ok} ${okWord}, ${fail} gagal`);
};

// === PDF dokumen (C4) ===
// Unduh & buka PDF dokumen (fetch blob dgn auth, lalu buka tab baru).
// Catatan: PDF di-arsipkan OTOMATIS (best-effort) oleh backend saat di-generate &
// saat dokumen difinalisasi — tidak ada lagi aksi "Arsipkan" manual di UI.
export const openPdf = async (api, docType, docId, label = "Dokumen") => {
  const tid = toast.loading(`Menyiapkan PDF ${label}...`);
  try {
    const r = await api(`/api/v2/pdf/${docType}/${docId}`);
    if (!r.ok) {
      let msg = "Gagal membuat PDF";
      try { msg = (await r.json()).detail || msg; } catch (e) { /* noop */ }
      toast.error(typeof msg === "string" ? msg : "Gagal membuat PDF", { id: tid });
      return;
    }
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank", "noopener");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    toast.success(`PDF ${label} dibuka`, { id: tid });
  } catch (e) {
    toast.error("Gagal membuat PDF", { id: tid });
  }
};


// === Export Excel (Reporting Pack) ===
// Unduh file .xlsx (fetch blob dgn auth, lalu trigger download).
export const downloadFile = async (api, path, filename = "export.xlsx") => {
  const tid = toast.loading("Menyiapkan Excel...");
  try {
    const r = await api(path);
    if (!r.ok) {
      let msg = "Gagal export";
      try { msg = (await r.json()).detail || msg; } catch (e) { /* noop */ }
      toast.error(typeof msg === "string" ? msg : "Gagal export", { id: tid });
      return;
    }
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
    toast.success("Excel diunduh", { id: tid });
  } catch (e) {
    toast.error("Gagal export", { id: tid });
  }
};
